import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { getTnaimContentData, getTnaimTitleData } from '../../server/ServerFunc';
import CustomeTnaimPanelAndTable from './CustomeTnaimPanelAndTable';
import TnaimInfo from './TnaimInfo';
import AppHeaderGlobal from '../AppHeaderGlobal';
import AppFooter from '../AppFooter';

const TnaimInfoContainer = ({ isSeparate }) => {
    const [tnaimTitles, setTnaimTitles] = useState([]);
    const [tnaimContentList, setTnaimContentList] = useState([]); //??
    const [arrayTnaimData, setArrayTnaimData] = useState([]);
    const [isMobile, setIsMobile] = useState(false);

    const search = useLocation().search;

    useEffect(() => {
        const tikNumURL = new URLSearchParams(search).get("TikNum");
        getTnaimTitle(tikNumURL);
        setIsMobile(window.innerWidth < 768);
    }, []);

    useEffect(() => {
        const tikNumURL = new URLSearchParams(search).get("TikNum");
        if (tnaimTitles.length > 0) {
            getTnaimContent(tikNumURL);
        }
    }, [tnaimTitles])

    const getTnaimTitle = async (tikNum) => {
        const tnaimTitlesList = await getTnaimTitleData(tikNum);
        if (tnaimTitlesList.length > 0) {
            setTnaimTitles(tnaimTitlesList);
        } else {
            setTnaimTitles([]);
        }
    }

    const getTnaimContent = async (tikNum) => {
        const tnaimList = await getTnaimContentData(tikNum);
        if (tnaimList.length > 0) {
            setTnaimContentList(tnaimList);
            createTnaimDictionary(tnaimList)
        } else {
            setTnaimContentList([]);
        }
    }

    const createTnaimDictionary = (tnaimDataList) => {
        const tnDataList = tnaimDataList;
        const tnTitlesList = tnaimTitles;

        // Initialize an empty dictionary
        const tnaimDictionary = {};

        // Iterate over the processes array and populate the dictionary
        tnTitlesList.forEach(tnai => {
            const { tnaiCode, tnaiTitle, field4 } = tnai; //field4

            // Find steps related to the current tnaiCode
            const relatedSteps = tnDataList.filter(tnaiItem => tnaiItem.sugCode === tnaiCode);

            // Add entry to the dictionary
            tnaimDictionary[tnaiCode] = {
                tnaiTitle,
                field4,
                tnDataList: relatedSteps
            };
        });

        console.log('tnaimDictionary', tnaimDictionary);

        convertDictionaryToSortedArray(tnaimDictionary)
    }

    const convertDictionaryToSortedArray = (tDictionary) => {
        if (Object.entries(tDictionary).length > 0) {

            //1. Convert the dictionary to an array for sorting
            const keyValueTnaimArray = [];
            for (let key in tDictionary) {
                if (tDictionary.hasOwnProperty(key)) {
                    keyValueTnaimArray.push([key, tDictionary[key]]);
                }
            }

            //2. Sort the array based on the field4
            for (let i = 0; i < keyValueTnaimArray.length - 1; i++) {
                for (let j = 0; j < keyValueTnaimArray.length - i - 1; j++) {
                    if (keyValueTnaimArray[j][1].field4 > keyValueTnaimArray[j + 1][1].field4) {
                        // Swap elements if they are in the wrong order
                        const temp = keyValueTnaimArray[j];
                        keyValueTnaimArray[j] = keyValueTnaimArray[j + 1];
                        keyValueTnaimArray[j + 1] = temp;
                    }
                }
            }

            //3. Insert the sorted array a new array of objects
            const sortedTnaimArr = [];
            for (let k = 0; k < keyValueTnaimArray.length; k++) {
                sortedTnaimArr.push({
                    tCode: keyValueTnaimArray[k][0],
                    tTitle: keyValueTnaimArray[k][1].tnaiTitle,
                    tList: keyValueTnaimArray[k][1].tnDataList,
                    tField4: keyValueTnaimArray[k][1].field4
                })
            }
            console.log('sortedTnaimArr', sortedTnaimArr);

            // setArrayTnaimData(sortedTnaimArr);
            displayArrayData(sortedTnaimArr)
        } else {
            setArrayTnaimData([]);
        }
    }

    const displayArrayData = (tnainDataArr) => {
        // const copmToRender = [];
        const convertedArray = [];
        let countExpend = 0;
    
        console.log('tnainDataArr', tnainDataArr);
    
        if(tnainDataArr.length > 0) {
          for (let i = 0; i < tnainDataArr.length; i++) {
            const { tCode, tTitle, tList } = tnainDataArr[i];
            convertedArray.push({
              id: `.${countExpend}`,
              title: tTitle,
              key: countExpend,
              // expanded: countExpend === arrayTnaimData.length - 1 ? true : false,
              expanded: countExpend === 0 ? true : false,
              content: <CustomeTnaimPanelAndTable key={tCode} tnaiTitle={tTitle} tnaiDataList={tList} isExpend={countExpend}/>
            });
            // copmToRender.push(<CustomeTnaimPanelAndTable key={tCode} tnaiTitle={tTitle} tnaiDataList={tList} isExpend={countExpend} />)
            countExpend++;
          }
        } else {
        //   copmToRender.push(<div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>);
          convertedArray.push({
            id: `.${countExpend}`,
            title: "",
            key: countExpend,
            // expanded: countExpend === arrayTnaimData.length - 1 ? true : false,
            expanded: true,
            content: <div style={{ textAlign: "center", margin: "auto" }}>לא נמצאו נתונים</div>
          })
        }
        
        // console.log('convertedArray', convertedArray);
        setArrayTnaimData(convertedArray);
        // return copmToRender;
      }

    return (
        <>
			{ isSeparate && <AppHeaderGlobal /> }
			<div style={{ margin: (!isSeparate ? "-105px 0px 0px 0px" : ""), backgroundColor: "white" }} >
                { arrayTnaimData.length > 0 && <TnaimInfo PanelBarItemsExt={arrayTnaimData} isMobile={isMobile} /> }
            </div>
			{ isSeparate && <AppFooter /> }
		</> 
    )
}

export default TnaimInfoContainer